<section class="toast__title mat-body-small">
	@if(process().processStatus === "RUNNING"){
		<span>{{"Vorgang gestartet" | translate : "headline-process-started"}}</span>
	}
	@else if(process().processStatus === "COMPLETED"){
		<span>{{"Bereit zum Download" | translate : "headline-download-ready"}}</span>
	}
</section>
<section class="process__details">
	<strong class="mat-label-large">
			{{process().type}} · {{process().name}} · {{process().contextName}}
	</strong>
</section>

@if (process().processStatus === "COMPLETED") {
	@if(process().createdAt){
		 <app-date-time [date]="process().createdAt!"/>
	}
	<button mat-stroked-button (click)="onDownloadClick($event)">
		<ogs-m3-icon icon="download" matButtonIcon/>
		{{"Download" | translate : "label-download"}}
	</button>
}